import React from 'react'

export default function LearningRecommendation({ learningSections }) {
  return (
    <div className='w-full h-full bg-white dark:bg-rb-dark-mode border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter rounded-lg p-4'>
      <h1 className='font-bold text-xl py-2 dark:text-white'>Learning & Recommendations</h1>
      { learningSections.map((section) => (
        <div key={section.id} className='border-t border-rb-widget-border dark:border-rb-dark-mode-lighter py-2'>
          <h2 className='text-lg font-bold mb-2 dark:text-white'>{section.title}</h2>
          <p className='text-sm dark:text-gray-400'>{section.free_text}</p>
        </div>
      ))}
    </div>
  )
}